/**
 * Joins an absolute path (and optional query) to an instance base URL without
 * duplicating slashes when the base ends with `/`.
 */
export function resolveInstanceUrl(instanceBaseUrl: string, pathWithQuery: string): string {
  return new URL(pathWithQuery, instanceBaseUrl).href;
}
